import { render, staticRenderFns } from "./ContestTeaPlayerRating.vue?vue&type=template&id=361437f3&scoped=true&"
import script from "./ContestTeaPlayerRating.vue?vue&type=script&lang=js&"
export * from "./ContestTeaPlayerRating.vue?vue&type=script&lang=js&"
import style0 from "./ContestTeaPlayerRating.vue?vue&type=style&index=0&id=361437f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361437f3",
  null
  
)

export default component.exports